import React from "react";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";

const RelatedApplicationForm = () => {
  return (
    <>
      <Row>
        <Col sm="12" className="app-form-header">
          <h4 className="form-title">{S.APP_RELATED_APPLICATION_TITLE}</h4>
        </Col>
      </Row>

      <Row style={{ display: "flex", gap: 70 }}>
        <Row>
          <Col sm="12">
            <TextField name="policyNumber" label={S.APP_POLICY_NUMBER_LABEL} />
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <TextField name="email1" label={S.APP_U_W_EMAIL_LABEL} />
          </Col>
          <Col sm="12">
            <TextField name="email2" label={S.APP_ASSISTANT_EMAIL_LABEL} />
          </Col>

          <Row style={{ display: "flex", alignItems: "flex-end", flexWrap: "nowrap", gap: "10px" }}>
            <Col sm="1">
              <CheckboxField name="recon" label={S.APP_RECON_LABEL} labelPosition="above" />
            </Col>
            <Col sm="11">
              <SimpleDatePickerField name="reconDate" isFormMode showClear />
            </Col>
          </Row>
        </Row>
      </Row>
    </>
  );
};

export default RelatedApplicationForm;
